export default __webpack_public_path__ + "static/media/kwid-gallery-7.67cc423f.jpg";